<template>
  <div v-if="environment !== 'production'" class="note">
    <template v-if="environment === 'development'">Development Mode</template>
    <template v-if="environment === 'demo'">Demo Mode</template>
    <template v-if="environment === 'test'">Test Mode</template>
  </div>
</template>

<script>
export default {
  name: 'ComponentEnvironmentBanner',

  data() {
    return {
      environment: this.$globals.app.environment
    }
  }
}
</script>

<style lang="scss">
  .note {
    position: absolute;
    z-index: 100;
    top: 80px;
    left: 0;
    padding: 6px;
    background-color: $colour-warning;
    color: $colour-secondary;
    font-weight: bold;
  }

  .login {
    .note {
      top: 0 !important;
    }
  }
</style>
